import { setupPluralize } from '@sravni/utils/lib/pluralize';

export const pluralizeBanks = setupPluralize(['банке', 'банках', 'банках']);
